module.exports = __webpack_public_path__ + "img/back2.594e3c25.png";